// extracted by mini-css-extract-plugin
export var aiStarIcon = "_l3-2";
export var container = "_l3-4";
export var dismissButton = "_l3-3";
export var hasPaddingBottom = "_l3-6";
export var last = "_l3-e";
export var scrollbarThumb = "_l3-c";
export var scrollbarTrack = "_l3-b";
export var selected = "_l3-9";
export var spin = "_l3-1";
export var spinning = "_l3-0";
export var suggestionItem = "_l3-d";
export var suggestionsPanel = "_l3-5";
export var tonePill = "_l3-8";
export var tonesContainer = "_l3-7";
export var unselected = "_l3-a";